/**
 * L'espace vu du portail : qui y a accès, avec quel rôle, et qui en est
 * propriétaire.
 *
 * Ces formes décrivent EXACTEMENT ce que renvoient les routes `/accounts/*`
 * consommées par l'écran « Mon espace ». Elles vivent ici, et pas dans le
 * portail, parce que l'API en est l'autre extrémité : un champ qu'on ajoute
 * d'un côté doit cesser de compiler de l'autre.
 */
export const LIBELLES_ROLE_ESPACE = {
    OWNER: 'Propriétaire',
    ADMIN: 'Administrateur',
    MEMBER: 'Membre',
};
export const LIBELLES_PROFIL_ESPACE = {
    STANDARD: 'Accès standard',
    LECTURE_SEULE: 'Lecture seule',
};
export const ACCES_ESPACE = {
    MEMBER: { role: 'MEMBER', profil: 'STANDARD', libelle: 'Membre — accès standard' },
    MEMBER_LECTURE_SEULE: {
        role: 'MEMBER',
        profil: 'LECTURE_SEULE',
        libelle: 'Membre — lecture seule (expert-comptable, associé…)',
    },
    ADMIN: { role: 'ADMIN', profil: 'STANDARD', libelle: 'Administrateur — accès complet' },
};
/** L'accès affiché pour un couple rôle / profil. */
export function accesEspace(role, profil) {
    if (role === 'OWNER')
        return 'OWNER';
    if (role === 'ADMIN')
        return 'ADMIN';
    return profil === 'LECTURE_SEULE' ? 'MEMBER_LECTURE_SEULE' : 'MEMBER';
}
//# sourceMappingURL=space.js.map